import { http, camelify } from '../rest';

export function fetchInvitations(http, camelify, demo) {
  return {
    async execute() {
      let data;
      if (demo) {
        const file = await import('./fetchInvitations.data');
        data = file.default;
      } else {
        const response = await http.get('/client_invitations');
        data = response.data;
      }
      return data.map((invitation) => {
        const formattedInvitation = camelify(invitation);
        formattedInvitation.assets = 0;
        return formattedInvitation;
      });
    },
  };
}

export default fetchInvitations(http, camelify, process.env.DEMO);
